import { myloreLegal } from './legal-data.js';
const { operator, abuse } = myloreLegal;
/**
 * "MyLore" is the Russian market. Values copied verbatim from the previous shared code:
 * the user should not notice the brand split.
 */
export const brand = {
    id: 'mylore',
    name: 'Милор',
    names: { ru: 'Милор', en: 'MyLore' },
    domain: 'mylore.ru',
    landingExamplePath: '/p/1zPX3N7TgmSmYyKXPAgffw?from=landing',
    onboardingExamplePath: '/demo',
    locales: ['ru', 'en'],
    defaultLocale: 'ru',
    emailLocale: 'ru',
    bookLanguages: ['ru', 'en', 'uz', 'ko', 'ka', 'tr', 'tt'],
    // The one size every MyLore book has had; with a single size the wizard asks nothing.
    printSizes: [{ format: 'A5', names: { ru: 'A5, 148 × 210 мм', en: 'A5, 148 × 210 mm' } }],
    narration: {
        model: 'google/gemini-3.8-flash/text-to-speech',
        female: 'Callirrhoe',
        male: 'Iapetus',
    },
    currency: 'RUB',
    priceLocale: 'ru-RU',
    priceNotes: {
        ru: 'Все цены указаны в рублях и включают применимые налоги.',
        en: 'All prices are in Russian rubles and include applicable taxes.',
    },
    ogImageAlt: {
        ru: 'Разворот детской книги: ребёнок и звезда над холмами',
        en: 'A children’s book spread with a child and a star above the hills',
    },
    printHighQuality: {
        ru: 'Макет для печати в отличном качестве — подходит для книг А4',
        en: 'High-quality print layout suitable for A4 books',
    },
    // The ruble has no fractional part in prices: «1 490 ₽», not «1 490,00 ₽».
    priceFractionDigits: 0,
    planPrices: {
        book: 149_000,
        live_book: 249_000,
        gift_book: 549_000,
    },
    imagePackPrice: 49_000,
    support: { email: operator.email },
    legalVersion: myloreLegal.documentVersionId,
    abuse: { email: abuse.email },
    mor: { kind: 'self', sellerName: operator.shortName },
    paymentProviderName: 'ЮKassa',
};
//# sourceMappingURL=brand.js.map